import { render, staticRenderFns } from "./DecorationHead.vue?vue&type=template&id=69f8e670&scoped=true&"
import script from "./DecorationHead.vue?vue&type=script&lang=js&"
export * from "./DecorationHead.vue?vue&type=script&lang=js&"
import style0 from "./DecorationHead.vue?vue&type=style&index=0&id=69f8e670&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f8e670",
  null
  
)

export default component.exports